export enum Index {
  SET_DATA = "setIndexPageData",
  SET_META = "setIndexMetaData",
}

export const MetaDefault = {
  title: "MTK - Главная",
};

export const DataDefault = {
  manufacturers: [
    {
      image: "/images/1-logo-BTS-min.png",
      name: "BTS",
    },
    {
      image: "/images/2-logo-Bravo-min.png",
      name: "Bravo мебель",
    },
    {
      image: "/images/3-logo-SV-min.png",
      name: "SV мебель",
    },
    {
      image: "/images/4-logo-Soyuz-min.png",
      name: "Союз мебель",
    },
    {
      image: "/images/5-logo-Interior-min.png",
      name: "Интерьер центр",
    },
    {
      image: "/images/6-logo-Mebel-Market-min.png",
      name: "Мебель маркет",
    },
    {
      image: "/images/7-logo-FSM-min.png",
      name: "Фабрика современной мебели",
    },
    {
      image: "/images/8-logo-Olmeco-min.png",
      name: "Олмеко",
    },
    {
      image: "/images/9-logo-Mebeloni-min.png",
      name: "Мебелони",
    },
    {
      image: "/images/10-logo-Bryansk-min.png",
      name: "Брянск мебель",
    },
    {
      image: "/images/11-logo-Borinskoe-min.png",
      name: "Боринское",
    },
    {
      image: "/images/12-logo-RiAl-min.png",
      name: "Риал",
    },
    {
      image: "/images/13-logo-triYA-min.png",
      name: "Три Я",
    },
    {
      image: "/images/14-logo-Family-min.png",
      name: "Family",
    },
  ],
  buyers: [
    {
      image: "/images/client-1.png",
      name: "Мягко",
    },
    {
      image: "/images/client-2.png",
      name: "Интерьер & Свет",
    },
    {
      image: "/images/client-3.png",
      name: "Три медведя",
    },
    {
      image: "/images/client-4.png",
      name: "Мебельный Express",
    },
  ],
  banner: [
    {
      name: "Баннер",
      link: "/images/banner.png",
    },
  ],
  catalog: [
    {
      name: "Гостиные",
      icon: "Living",
      link: "/catalog/4",
    },
    {
      name: "Спальни",
      icon: "Bedroom",
      link: "/catalog/43",
    },
    {
      name: "Детские",
      icon: "Baby",
      link: "/catalog/28",
    },
    {
      name: "Шкафы",
      icon: "Wardrobe",
      link: "/catalog/25",
    },
    {
      name: "Кухни",
      icon: "Kitchen",
      link: "/catalog/57",
    },
    {
      name: "Смотреть еще",
      icon: "Hanger",
      link: "/catalog/",
    },
  ],
  advantages: [
    {
      icon: "Payment",
      title: "Любая форма оплаты",
      description:
        "Оплата заказа банковской картой, наличным и безналичным расчетом",
    },
    {
      icon: "Storage",
      title: "Бесплатное хранение",
      description: "Хранение вашего товара на нашем складе абсолютно бесплатно",
    },
    {
      icon: "Discount",
      title: "Акции",
      description: "Регулярные сезонные акции с ещё большей выгодой",
    },
  ],
  reviews: [
    {
      image: "/images/profile.png",
      name: "Виктор",
      surname: "Абросимов",
      company: "ИП Абросимов, магазин «Мебель»",
      position: "Директор",
      text:
        "Выражаем искреннюю благодарность коллективу МТК Ерёмина С.В. за ответственное и качественное выполнение услуг поставки товара и приему заказов нашего магазина.<br> Благодарим за Ваш профессионализм!",
    },
    {
      image: "/images/profile.png",
      name: "Юлия",
      surname: "Пузанова",
      company: "ООО «ТС ЛАНА»",
      position: "Менеджер по продажам",
      text:
        "Это безусловно удобное и выгодное сотрудничество. При выборе партнера мы руководствовались на ценовую доступность и разнообразие товара. У компании МТК есть всё!",
    },
    {
      image: "/images/profile.png",
      name: "Ирэн",
      surname: "Адлер",
      company: "«Энергия»",
      position: "Директор",
      text:
        "Дорогие мои коллеги, спасибо вам за каждый день, словно праздник, за чудесное настроение и постоянную поддержку, за верные советы и совместные достижения.",
    },
  ],
  certificates: [
    {
      name: "Сертификат",
      image: "/images/cert-1.jpg",
    },
    {
      name: "Сертификат",
      image: "/images/cert-2.jpg",
    },
    {
      name: "Сертификат",
      image: "/images/cert-3.jpg",
    },
    {
      name: "Сертификат",
      image: "/images/cert-4.jpg",
    },
    {
      name: "Сертификат",
      image: "/images/cert-5.jpg",
    },
    {
      name: "Сертификат",
      image: "/images/cert-6.jpg",
    },
  ],
  contacts: {
    address: "г. Курск, пр-т Кулакова 51",
    phone: "8 (800) 550-44-46",
    extradition:
      "Пн-Пт: 9:00-18:00, пер. 13:00-14:00 <br>Сб: 9:00-14:00, без перерыва",
    link: "https://yandex.ru/maps/-/CCQFqSGH~D",
  },
  banners: {
    longBanner: {
      name: "Баннер",
      image: "/images/880х200-photo-min.png",
    },
    middleBanner: {
      name: "Баннер",
      image: "/images/580х200-soyuz-kids-min.png",
    },
    smallBannerOne: {
      name: "Баннер",
      image: "/images/280х200-kitchen-min.png",
    },
    smallBannerTwo: {
      name: "Баннер",
      image: "/images/280х200-discounts-min.png",
    },
    smallBannerThree: {
      name: "Баннер",
      image: "/images/280х200-sv-livingroom-min.png",
    },
  },
  sale: [],
  mainSlider: [
    {
      name: "Слайд 1",
      image: "/images/Slider-1.png",
      link: "/catalog/",
    },
    {
      name: "Слайд 2",
      image: "/images/Slider-2.png",
      link: "/catalog/",
    },
    {
      name: "Слайд 3",
      image: "/images/Slider-3.png",
      link: "/catalog/",
    },
    {
      name: "Слайд 4",
      image: "/images/Slider-4.png",
      link: "/catalog/",
    },
  ],
};
